// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1QyK0","signatureBlock":"Footer_signatureBlock__2QO9b","signature":"Footer_signature__2ErpW"};